import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';

class Tooltip extends React.Component {
    constructor(props) {
        super(props);

        this.close = this.close.bind(this);
    }

    close() {
        const { doClose } = this.props;
        doClose();
    }

    render() {
        const { children } = this.props;
        return (
            <span>
                <span>
                    <i
                        onClick={this.close}
                        role="button"
                        tabIndex={0}
                    >
                        <CloseIcon />
                    </i>
                    {children}
                </span>
            </span>
        );
    }
}

Tooltip.propTypes = {
    children: PropTypes.node.isRequired,
    doClose: PropTypes.func,
};

Tooltip.defaultProps = {
    doClose: () => { },
};

export default Tooltip;
